'use client';

import { useState } from 'react';
import DesktopGalleryNavigation from './gallery-carousel/desktop-navigation';
import GalleryCarousel from './gallery-carousel/gallery-carousel';
function Gallery() {
  const [activeIndex, setActiveIndex] = useState(0);
  const onSlideChange = (index: number) => {
    setActiveIndex(index);
  };
  return <div className='relative col-span-full mb-2 gap-1 lg:col-span-4 lg:mb-0 lg:mt-8 lg:flex' data-sentry-component="Gallery" data-sentry-source-file="gallery.tsx">
            <DesktopGalleryNavigation onActiveIndexChange={onSlideChange} activeIndex={activeIndex} numberOfVisibleItems={5} data-sentry-element="DesktopGalleryNavigation" data-sentry-source-file="gallery.tsx" />

            <GalleryCarousel onSlideChange={onSlideChange} activeIndex={activeIndex} data-sentry-element="GalleryCarousel" data-sentry-source-file="gallery.tsx" />
        </div>;
}
export default Gallery;